export const WHATSAPP_LINK = "https://chat.whatsapp.com/E6giff7453L6dNrf0ekjik";
export const DISCORD_LINK = "https://discord.gg/hsytswuT3y";
export const PATREON_LINK = "https://www.patreon.com/ICS_Shariah";
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_halal-finance-9/artifacts/csmdkeql_image.png";
export const SUPPORT_EMAIL = "support@icsmarkets.online";

// Social Media Links
export const SOCIAL_LINKS = {
  youtube: "https://www.youtube.com/@InvestmentCircleofShariaICS",
  patreon: PATREON_LINK,
  whatsapp: WHATSAPP_LINK,
  facebook: "https://www.facebook.com/profile.php?id=61559982579903",
  twitter: "https://x.com/ICS_MARKETS",
  instagram: "https://www.instagram.com/ics_markets/",
};
